var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "notes-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26662 0C3.70368 0 0.815166 2.94261 0.815166 6.57229C0.815166 7.74339 1.11896 8.84022 1.64575 9.7922C1.64696 9.7953 1.64514 9.79963 1.64636 9.80149C1.77274 10.0181 1.91309 10.4985 1.91309 10.9652C1.91309 11.7878 1.63603 12.3145 0.965242 12.9973C0.501039 13.4702 0.131013 13.8434 0.0143545 13.961C-0.0111646 13.987 -0.00265823 14 0.0398735 14H7.26662C11.2348 14 14 10.3994 14 7.05323C14 3.70643 11.8127 1.90892 11.8127 1.90892C10.6467 0.729154 9.04019 0 7.26662 0ZM7.26662 1.08321C8.69751 1.08321 10.0458 1.65019 11.0629 2.67831L11.5453 3.16606C12.0739 3.78813 12.9367 5.10284 12.9367 7.05323C12.9367 9.82624 10.6084 12.9168 7.26662 12.9168H2.41557C2.74611 12.4068 2.97639 11.7872 2.97639 10.9652C2.97639 10.5164 2.88282 10.0163 2.73213 9.61641L2.73274 9.61456L2.72606 9.60094C2.69325 9.51366 2.6574 9.43134 2.61912 9.35582L2.61608 9.35025L2.59603 9.30445L2.57173 9.2605C2.11846 8.44036 1.87846 7.51066 1.87846 6.57229C1.87846 3.54611 4.29548 1.08321 7.26662 1.08321Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.83b55e82ae29ad45e5211776eaa4c97e.svg";
export { ForwardRef as ReactComponent };